const mapGridTemplateToElement = (template) => {
  const matches = template.matchAll(/(['"])(.*?)\1/g);
  const flatZones = [...matches].flatMap((x) => x[2] && x[2].split(/\s+/));
  return flatZones.filter((value, index, array) => array.indexOf(value) === index);
};
export default mapGridTemplateToElement;
